import {
  ListProps,
  TextField,
  RichTextField,
  ReferenceField,
} from 'react-admin';

import {
  BooleanField,
  TextInput,
  Grid,
  GridList,
  PhoneField,
  EmailField,
  Forbidden,
  NullableBooleanInput,
  DateField,
} from '@components';
import { useRbacList } from '@hooks';
import { checkSuperadmin } from '@providers';
import cls from './WebinarSignupList.module.css';

export const WebinarSignupList = (props: ListProps) => {
  const isSuperadmin = checkSuperadmin();
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
      className={cls.list}
    >
      <Grid
        rowClick="edit"
        defaultColumns={
          'id webinarId fullName phone company createdAt visited'.split(' ')
        }
        className={cls.grid}
      >
        <TextField source="id" label="ID" />
        {isSuperadmin ? (
          <ReferenceField reference="webinar-list" source="webinarId" label="Webinar">
            <TextField source="titleMx" />
          </ReferenceField>
        ) : (
          <TextField source="webinar-list.titleMx" label="Webinar" />
        )}
        <TextField source="fullName" label="Full Name" />
        <PhoneField source="phone" isText label="Phone" />
        <EmailField source="email" isText wrap label="Email" />
        <EmailField source="company" isText label="Company" />
        <BooleanField source="visited" disabled label="Visited" />
        <DateField source="visitedAt" showTime label="Visited At" />
        <RichTextField source="questions" label="Questions" />
        <DateField source="createdAt" label="Created At" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" variant="outlined" label="Search" alwaysOn />,
  <NullableBooleanInput source="visited" key="visited" alwaysOn />,
];
